import React from "react"
import { default as SlickSlider } from "react-slick";
import "slick-carousel/slick/slick-theme.css";
import "slick-carousel/slick/slick.css";
import "style/CMSSlider.scss"
// import "react-responsive-carousel/lib/styles/carousel.min.css"


export default class CMSSlider extends React.Component {

  state = {
    isDragging: false
  }

  toggleDragging = () => this.setState( { isDragging: !this.state.isDragging } );
  onClickHandler = ( event ) => {
    if ( this.props.isDragging ) {
      event.preventDefault();
    } else {
      return true
    }
  };

  render() {

    const { slidesToShow = 1, autoplaySpeed = 3000, autoplay = false, slidesToScroll = 1, centerMode = false, centerPadding = "0px", dots = true, arrows = false, speed = 500 } = this.props
    const settings = {
      dots,
      infinite: true,
      speed,
      arrows,
      slidesToShow,
      slidesToScroll,
      centerMode,
      centerPadding,
      autoplay,
      autoplaySpeed
    };

    const { isDragging } = this.state
    return (
      <React.Fragment>
        <SlickSlider {...settings}
                     className={`CMSSlider${arrows ? '' : ' CMSSlider--no-arrows'}`}
        >
          {this.props.children}
        </SlickSlider>
      </React.Fragment>
    );
  }
}


// WEBPACK FOOTER //
// ./src/components/Slider/Slider.js